import { render } from "./thirdPartySection.vue?vue&type=template&id=95c81ac2"
import script from "./thirdPartySection.vue?vue&type=script&lang=js"
export * from "./thirdPartySection.vue?vue&type=script&lang=js"

import "./thirdPartySection.vue?vue&type=style&index=0&id=95c81ac2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__